import {
  Button,
  Card,
  DatePicker,
  Col,
  Row,
  Select,
  Spin,
  message,
  Form,
  Image,
  Drawer,
} from "antd";
import withRouter from "../withRouter";

import { Map, GoogleApiWrapper, HeatMap } from "google-maps-react";
import React from "react";
import Draggable from "react-draggable";
import dayjs from "dayjs";
import { observer } from "mobx-react";
import { addMinutes, format } from "date-fns";
import moment from "moment";
import HeatMapStore from "../store/HeatMapStore";
import conf from "../config";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { StoreContext } from "../store/RootStore";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "universal-cookie";
import openDrawerIcon from "../assets/images/NewDesign/livetracking/openDrawer.svg";

const currentDate = moment().format("YYYY-MM-DD");
const startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
const endTime = new Date(2000, 0, 1, 23, 30); // 11:45 PM
const curreentDate = dayjs();

const timeArray = [];
for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
  const formattedTime = format(time, "HH:mm:ss");
  var ob = {
    formattedTime: formattedTime,
    time: time,
  };
  timeArray.push(ob);
}

class HeatMapShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      traffic: false,
      flag: true,
      mapBtn: false,
      satelliteBtn: false,
      spinLoading: false,
      mapType: "google",
      mapReady: false,
      setOpacity: false,
      setRadius: false,
      setGradient: false,
      updateKey: "",
      toggleHeatmap: false,
      loadingSpin: false,
      vehicleId: "",
      mapBounds: null,
      openHeatMapForm: false,
      vehicleLoading: false
    };
    this.cookies = new Cookies();
    this.formRef = React.createRef();
    this.mapRef = React.createRef();
    this.heatMapStore = new HeatMapStore(this);
    this.isadmin = JSON.parse(base64_decode(this.cookies.get("data")));

    this.mapOptions = [
      {
        label: "Google",
        value: "google",
      },
      {
        label: "Openstreet",
        value: "openstreet",
      },
    ];
  }

  handleChange = async (comp) => {
    console.log(comp.value);
    this.setState({ vehicleLoading: true });
    this.heatMapStore.heatMapArray = [];
    await this.formRef.current.setFieldsValue({ vehicleId: undefined });
    await this.heatMapStore.getVehicle({ companyId: comp.value });
    await this.setState({ update: 1 });
    this.setState({ vehicleLoading: false });
  };

  heatMapShowFunc = async (obj) => {
    console.log(obj.toTime, this.state.vehicleId);
    this.heatMapStore.heatMapArray = [];

    var fromDate = dayjs(obj.fromDate).format("YYYY-MM-DD");
    var toDate = dayjs(obj.toDate).format("YYYY-MM-DD");
    var fromTime = obj.fromTime;
    var toTime = obj.toTime
      ? dayjs(obj.toTime, "hh:mm A").format("HH:mm:ss")
      : dayjs().format("HH:mm:ss");

    var data = {
      // companyId: obj.companyId?.value,:
      companyId: obj.companyId?.value
        ? obj.companyId?.value
        : this.state.companyId,
      vehicleId: obj.vehicleId, // Update vehicleId here
      fromDate: fromDate + " " + fromTime,
      toDate: toDate + " " + toTime,
    };
    await this.setState({ loadingSpin: true });
    const resp = await this.heatMapStore.getHeatMapData(data);
    if (resp === 0) {
      // message.warning({ content: "Vehicle Data Not Available..." });
      this.setState({ loadingSpin: false });
      message.warning({
        content: this.context.translate("_VEHICLE_DATA_NOT_AVAILABLE_"),
      });

      return;
    }
    await this.calculateBounds();
    await this.setState({
      update: 2,
      vehicleId: this.state.vehicleId,
      loadingSpin: false,
      openHeatMapForm: false,
      lastFormValues: obj,
    }); // Update vehicleId in state
  };

  calculateBounds = () => {
    const positions = this.heatMapStore.heatMapArray;
    const bounds = new this.props.google.maps.LatLngBounds();

    positions.forEach((position) => {
      bounds.extend(position);
    });

    this.setState({ mapBounds: bounds });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.openHeatMapForm &&
      !prevState.openHeatMapForm &&
      this.state.lastFormValues
    ) {
      this.formRef.current?.setFieldsValue(this.state.lastFormValues);
    }
  }

  async componentDidMount() {
    const data = JSON.parse(base64_decode(this.cookies.get("data")));
    console.log(JSON.parse(base64_decode(this.cookies.get("data"))));
    if (Number(data.isadmin) !== -1 && Number(data.isadmin) !== 3) {
      console.log(data.userCompanyId);
      await this.setState({ companyId: data.userCompanyId });

      // await this.setState({ userId: this.props.getUserData().userId })
      await this.heatMapStore.getVehicle({ companyId: data.userCompanyId });

      // await this.handleSearch();
    }
    this.setState({ update: 1 });
  }

  clearMap = () => {
    this.state.mapBounds = null;
    this.heatMapStore.heatMapArray = [];
    this.state.setGradient = null;
    this.setState({ update: 1 });
  };

  render() {
    const gradient = [
      "rgba(0, 255, 255, 0)",
      "rgba(0, 255, 255, 1)",
      "rgba(0, 191, 255, 1)",
      "rgba(0, 127, 255, 1)",
      "rgba(0, 63, 255, 1)",
      "rgba(0, 0, 255, 1)",
      "rgba(0, 0, 223, 1)",
      "rgba(0, 0, 191, 1)",
      "rgba(0, 0, 159, 1)",
      "rgba(0, 0, 127, 1)",
      "rgba(63, 0, 91, 1)",
      "rgba(127, 0, 63, 1)",
      "rgba(191, 0, 31, 1)",
      "rgba(255, 0, 0, 1)",
    ];

    const hexColors =
      "#F51D27-#FA541C-#FF8C12-#FFC838-#FAFFA8-#80FF73-#12CCCC-#1890FF-#6E32C2".split(
        "-"
      );

    // Convert hex to rgba with full opacity
    const hexToRgba = (hex, alpha = 1) => {
      const bigint = parseInt(hex.replace("#", ""), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    // Create the gradient array
    const gradient2 = hexColors.map((hex) => hexToRgba(hex));

    return (
      <div style={{ overflow: "hidden" }}>
        <div>
          <Map
            zoom={conf.mapZoom}
            ref={this.mapRef}
            google={this.props.google}
            bounds={this.state.mapBounds}
            style={{ position: "sticky", height: "90vh", width: "100wh" }}
            containerStyle={{
              position: "static",
              // width: '95%',
              // left:"10%",
              // height: '100%'
            }}
            zoomControl={true}
            zoomControlOptions={{
              position: this.props.google.maps.ControlPosition.RIGHT_TOP,
            }}
            streetViewControl={true}
            streetViewControlOptions={{
              position: this.props.google.maps.ControlPosition.RIGHT_TOP,
            }}
            mapTypeControlOptions={{
              style: this.props.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: this.props.google.maps.ControlPosition.TOP_RIGHT,
            }}
            fullscreenControl={false}
            className={"map"}
            // initialCenter={{
            //   lat: 25.276987,
            //   lng: 55.296249,
            // }}
            initialCenter={
              {
                lat: conf.mapCenter[0],
                lng: conf.mapCenter[1],
              }
            }
            onReady={this.handleMapReady}
          >
            {this.heatMapStore.heatMapArray.length > 0 && (
              <HeatMap
                // gradient={this.state.setGradient ? gradient : null}
                gradient={gradient}
                positions={
                  this.state.toggleHeatmap ? [] : this.heatMapStore.heatMapArray
                }
                // opacity={this.state.setOpacity ? 0.5 : 1}
                opacity={0.5}
                // radius={this.state.setRadius ? 20 : 10}
                radius={20}
                key={this.state.updateKey}
              />
            )}
          </Map>
        </div>

        <div
          className="heatMapOpenDrawerBtn"
          onClick={() => {
            this.setState({
              openHeatMapForm: true,
            });
          }}
        >
          <Image src={openDrawerIcon}></Image>
        </div>

        {this.state.openHeatMapForm && (
          <Drawer
            className="uploadExcelDrawer heatMapDrawer"
            style={{
              height: "88vh",
              width: "380px",
              position: "relative",
              top: "66px",
            }}
            destroyOnClose={false}
            closeIcon={false}
            footer={false}
            open={this.state.openHeatMapForm}
            // title={<span>{this.context.translate("Heat Map")}</span>}
            maskClosable={false}
            onOk={() => {
              this.setState({ openHeatMapForm: false });
            }}
            onCancel={() =>
              this.setState({
                openHeatMapForm: false,
              })
            }
          >
            <Spin spinning={this.state.loadingSpin}>
              <Form
                ref={this.formRef}
                layout="vertical"
                name="nest-messages"
                onFinish={this.heatMapShowFunc}
                className="formClass"
                style={{ maxWidth: "100%", padding: 0, height: "%" }}
                initialValues={this.state.lastFormValues}
              >
                <div
                  style={{
                    marginBottom: "6px",
                    marginTop: "4px",
                    color: "#262626",

                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "130%",
                  }}
                >
                  <span>Heat Map</span>
                </div>
                {(Number(this.isadmin.isadmin) === -1 ||
                  Number(this.isadmin.isadmin) === 3) && (
                    <Form.Item
                      name="companyId"
                      // rules={[{ required: true }]}
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_DASHBORD_NEWPOI_COMPANY_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Company is required",
                        },
                      ]}
                      required={false}
                      className="uploadCompany"
                    // style={{ marginBottom: "2px", marginTop: "2px" }}
                    >
                      <CompanyAutocomplete
                        onChange={(val) => this.handleChange(val)}
                      />
                    </Form.Item>
                  )}

                <Form.Item
                  name="vehicleId"
                  // label="Vehicle"
                  label={
                    <span>
                      {this.context.translate("_VEHICLES_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Vehicle is required",
                    },
                  ]}
                  required={false}
                  style={{ marginBottom: "6px", marginTop: "6px" }}
                >
                  {/* <Spin spinning={this.heatMapStore.vehicleLoading}> */}
                  <Select
                    // placeholder="Select Vehicle"
                    placeholder={this.context.translate("_SELECT_VEHICLE_")}
                    optionFilterProp="children"
                    onChange={(v) => {
                      this.setState({ vehicleId: v });
                    }}
                    showSearch
                    value={this.state.vehicleId}
                    loading={this.state.vehicleLoading}
                    disabled={this.state.vehicleLoading} // ⭐ block click
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.heatMapStore.vehicleArray?.map((v) => {
                      return (
                        <Select.Option value={v.vehicleId}>
                          {v.vehicleNo}
                        </Select.Option>
                      );
                    })}
                  </Select>
                  {/* </Spin> */}
                </Form.Item>

                <Row>
                  <Col span={12}>
                    <Form.Item
                      name="fromDate"
                      // label="From Date"
                      label={this.context.translate("_FROM_DATE_")}
                      initialValue={dayjs()}
                      style={{
                        marginBottom: "6px",
                        marginTop: "6px",
                        marginInlineEnd: "10px",
                      }}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format={"YYYY-MM-DD"}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="fromTime"
                      // label="From Time"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[
                        {
                          required: true,
                          message: "From time is required",
                        },
                      ]}
                      required={false}
                      style={{
                        marginBottom: "6px",
                        marginTop: "6px",
                        marginInlineStart: "10px",
                      }}
                      initialValue={"00:00:00"}
                    >
                      <Select
                        onChange={(val) =>
                          this.formRef.current.setFieldsValue({
                            fromTime: val,
                          })
                        }
                        allowClear={true}
                      >
                        {timeArray.map((data) => {
                          return (
                            <Select.Option
                              key={data.formattedTime}
                              value={data.formattedTime}
                            >
                              {format(data.time, "h:mm aa")}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span={12}>
                    <Form.Item
                      name="toDate"
                      label={this.context.translate("_TO_DATE_")}
                      initialValue={dayjs()}
                      style={{
                        marginBottom: "6px",
                        marginTop: "6px",
                        marginInlineEnd: "10px",
                      }}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format={"YYYY-MM-DD"}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="toTime"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      rules={[
                        {
                          required: true,
                          message: "To Time is required",
                        },
                      ]}
                      required={false}
                      style={{
                        marginBottom: "6px",
                        marginTop: "6px",
                        marginInlineStart: "10px",
                      }}
                      initialValue={dayjs().format("hh:mm A ")}
                    >
                      <Select
                        onChange={(val) => {
                          if (val) {
                            this.formRef.current.setFieldsValue({
                              toTime: dayjs(val, "HH:mm:ss").format("hh:mm A "),
                            });
                          } else {
                            this.formRef.current.setFieldsValue({
                              toTime: null,
                            });
                          }
                        }}
                        allowClear={true}
                      >
                        {timeArray.map((data) => {
                          return (
                            <Select.Option
                              key={data.formattedTime}
                              value={data.formattedTime}
                            >
                              {format(data.time, "h:mm aa")}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <div className="formFooter">
                  <Button
                    className="formsCancelButton"
                    onClick={() => {
                      this.setState({ openHeatMapForm: false });
                    }}
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button
                    htmlType="submit"
                    loading={this.state.loadingSpin}
                    className="formsSaveButton"
                  >
                    {this.context.translate("_FLEET_SHOW_BTN_")}
                  </Button>
                </div>
              </Form>
            </Spin>
            {/* </Card> */}
          </Drawer>
        )}
      </div>
    );
  }
}

HeatMapShow.contextType = StoreContext;
export default GoogleApiWrapper({
  apiKey: conf.googleMapKey,
  libraries: ["visualization"],
  version: "3.64",
})(HeatMapShow);
observer(withRouter(HeatMapShow));
